import { Divider as AntDivider, Space, Tag as AntTag } from 'antd';
import styled from 'styled-components';

import { Button } from '@atom/button/button';
import { Text } from '@atom/typography/typography';
import { InviteStatusEnum } from '@enum/invite-status.enum';
import { ColorEnum } from '@enum/style/color.enum';

export const Wrapper = styled.div`
  padding-right: 24px;
`;

export const Divider = styled(AntDivider)`
  margin-bottom: 8px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding: 15px 0 24px;
  gap: 24px;
`;

export const InviteButton = styled(Button)`
  max-width: 320px;
`;

export const FormWrapper = styled.div`
  padding-top: 16px;
`;

export const FormInnerWrapper = styled.div`
  padding-top: 8px;
`;

export const FooterWrapper = styled(Space).attrs({
  direction: 'horizontal',
})`
  padding-top: 24px;
`;

export const CancelButtonTitle = styled(Text).attrs((props) => ({
  color: props.theme.Title.colorConsumerButtonTitle,
}))``;

interface TagProps {
  status: InviteStatusEnum;
}

export const TagStatus = styled(AntTag)<TagProps>`
  border-radius: 0 4px;
  padding: 0 7px;
  color: ${ColorEnum.Black100};
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 8px;
  text-transform: capitalize;

  background-color: ${(props) =>
    props.status === InviteStatusEnum.Active
      ? ColorEnum.Green1
      : props.status === InviteStatusEnum.Suspended
        ? ColorEnum.Red1
        : ColorEnum.Gold1};
  border-color: ${(props) =>
    props.status === InviteStatusEnum.Active
      ? ColorEnum.Green3
      : props.status === InviteStatusEnum.Suspended
        ? ColorEnum.Red3
        : ColorEnum.Gold3};
  color: ${(props) =>
    props.status === InviteStatusEnum.Active
      ? ColorEnum.Green6
      : props.status === InviteStatusEnum.Suspended
        ? ColorEnum.Red6
        : ColorEnum.Gold6};
`;
